// round 1 reset functions

export const starter_reset_payload_round1 = (HeartM,SoulM,MindM,StrengthM,HeartL,SoulL,MindL,StrengthL) => {
  return [
    {
      "answer": HeartM,
      "id": 2525,
      "orderNo": 312,
      "clientId": 78,
      "pageId": 1004,
      "sectionId": 296,
      "question": "MOST HEART RESET",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_h_m",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 08:04:22",
      "updatedAt": "2024-12-26 08:04:22",
      "answers": [
        {
          "id": 10073,
          "clientId": 78,
          "questionId": 2227,
          "orderNo": 2,
          "desktopText": "heart reset",
          "mobileText": "heart reset",
          "value": 0,
          "createdAt": "2024-12-26 08:04:22",
          "updatedAt": "2024-12-26 08:04:22"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": SoulM,
      "id": 2526,
      "orderNo": 313,
      "clientId": 78,
      "pageId": 1004,
      "sectionId": 296,
      "question": "MOST SOUL RESET\n",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_s_m",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 08:05:45",
      "updatedAt": "2024-12-26 08:05:45",
      "answers": [
        {
          "id": 10074,
          "clientId": 78,
          "questionId": 2228,
          "orderNo": 1,
          "desktopText": "soul most reset",
          "mobileText": "soul most reset",
          "value": 0,
          "createdAt": "2024-12-26 08:05:45",
          "updatedAt": "2024-12-26 08:05:45"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": MindM,
      "id": 2527,
      "orderNo": 314,
      "clientId": 78,
      "pageId": 1004,
      "sectionId": 296,
      "question": "MOST MIND RESET",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_md_m",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 08:06:39",
      "updatedAt": "2024-12-26 08:06:39",
      "answers": [
        {
          "id": 10075,
          "clientId": 78,
          "questionId": 2229,
          "orderNo": 1,
          "desktopText": "MOST MIND RESET",
          "mobileText": "MOST MIND RESET",
          "value": 0,
          "createdAt": "2024-12-26 08:06:39",
          "updatedAt": "2024-12-26 08:06:39"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": StrengthM,
      "id": 2528,
      "orderNo": 315,
      "clientId": 78,
      "pageId": 1004,
      "sectionId": 296,
      "question": "MOST STRENGTH RESET",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_st_m",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 08:06:55",
      "updatedAt": "2024-12-26 08:06:55",
      "answers": [
        {
          "id": 10076,
          "clientId": 78,
          "questionId": 2230,
          "orderNo": 1,
          "desktopText": "MOST STRENGTH RESET",
          "mobileText": "MOST STRENGTH RESET",
          "value": 0,
          "createdAt": "2024-12-26 08:06:55",
          "updatedAt": "2024-12-26 08:06:55"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": HeartL,
      "id": 2529,
      "orderNo": 316,
      "clientId": 78,
      "pageId": 1004,
      "sectionId": 296,
      "question": "LEAST HEART RESET",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_h_l",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 09:53:07",
      "updatedAt": "2024-12-26 09:53:07",
      "answers": [
        {
          "id": 10077,
          "clientId": 78,
          "questionId": 2231,
          "orderNo": 1,
          "desktopText": "LEAST HEART RESET",
          "mobileText": "LEAST HEART RESET",
          "value": 0,
          "createdAt": "2024-12-26 09:53:07",
          "updatedAt": "2024-12-26 09:53:07"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": SoulL,
      "id": 2530,
      "orderNo": 317,
      "clientId": 78,
      "pageId": 1004,
      "sectionId": 296,
      "question": "LEAST SOUL RESET",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_s_l",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 09:53:24",
      "updatedAt": "2024-12-26 09:53:24",
      "answers": [
        {
          "id": 10078,
          "clientId": 78,
          "questionId": 2232,
          "orderNo": 1,
          "desktopText": "LEAST SOUL RESET",
          "mobileText": "LEAST SOUL RESET",
          "value": 0,
          "createdAt": "2024-12-26 09:53:24",
          "updatedAt": "2024-12-26 09:53:24"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": MindL,
      "id": 2531,
      "orderNo": 318,
      "clientId": 78,
      "pageId": 1004,
      "sectionId": 296,
      "question": "LEAST MIND RESET",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_md_l",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 09:53:34",
      "updatedAt": "2024-12-26 09:53:34",
      "answers": [
        {
          "id": 10079,
          "clientId": 78,
          "questionId": 2233,
          "orderNo": 1,
          "desktopText": "LEAST MIND RESET",
          "mobileText": "LEAST MIND RESET",
          "value": 0,
          "createdAt": "2024-12-26 09:53:34",
          "updatedAt": "2024-12-26 09:53:34"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": StrengthL,
      "id": 2532,
      "orderNo": 319,
      "clientId": 78,
      "pageId": 1004,
      "sectionId": 296,
      "question": "LEAST STRENGTH RESET",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_st_l",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 09:53:48",
      "updatedAt": "2024-12-26 09:53:48",
      "answers": [
        {
          "id": 10080,
          "clientId": 78,
          "questionId": 2234,
          "orderNo": 1,
          "desktopText": "LEAST STRENGTH RESET",
          "mobileText": "LEAST STRENGTH RESET",
          "value": 0,
          "createdAt": "2024-12-26 09:53:48",
          "updatedAt": "2024-12-26 09:53:48"
        }
      ],
      "logic": [],
      "questionLanguages": []
    }
  ]
}

export const leader_reset_payload_round1 = (per_m,strat_m,vis_m,col_m,per_l,strat_l,vis_l,col_l) => {
  return [
    {
      "answer": per_m,
      "id": 2533,
      "orderNo": 320,
      "clientId": 78,
      "pageId": 1005,
      "sectionId": 297,
      "question": "MOST PERFORMANCE RESET",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_p_m",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 12:10:58",
      "updatedAt": "2024-12-26 12:10:58",
      "answers": [],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": strat_m,
      "id": 2534,
      "orderNo": 321,
      "clientId": 78,
      "pageId": 1005,
      "sectionId": 297,
      "question": "MOST STRATEGIC RESET",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_str_m",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 12:11:53",
      "updatedAt": "2024-12-26 12:11:53",
      "answers": [
        {
          "id": 10082,
          "clientId": 78,
          "questionId": 2237,
          "orderNo": 1,
          "desktopText": "most strategic reset",
          "mobileText": "most strategic reset",
          "value": 0,
          "createdAt": "2024-12-26 12:11:53",
          "updatedAt": "2024-12-26 12:11:53"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": vis_m,
      "id": 2535,
      "orderNo": 322,
      "clientId": 78,
      "pageId": 1005,
      "sectionId": 297,
      "question": "MOST VISIONARY RESET",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_vis_m",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 12:13:01",
      "updatedAt": "2024-12-26 12:13:01",
      "answers": [
        {
          "id": 10083,
          "clientId": 78,
          "questionId": 2238,
          "orderNo": 1,
          "desktopText": "most visionary reset",
          "mobileText": "most visionary reset",
          "value": 0,
          "createdAt": "2024-12-26 12:13:01",
          "updatedAt": "2024-12-26 12:13:01"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": col_m,
      "id": 2536,
      "orderNo": 323,
      "clientId": 78,
      "pageId": 1005,
      "sectionId": 297,
      "question": "MOST COLLABORATIVE RESET",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_col_m",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 12:13:35",
      "updatedAt": "2024-12-26 12:13:35",
      "answers": [
        {
          "id": 10084,
          "clientId": 78,
          "questionId": 2239,
          "orderNo": 1,
          "desktopText": "most collaborative reset",
          "mobileText": "most collaborative reset",
          "value": 0,
          "createdAt": "2024-12-26 12:13:35",
          "updatedAt": "2024-12-26 12:13:35"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer":per_l,
      "id": 2537,
      "orderNo": 324,
      "clientId": 78,
      "pageId": 1005,
      "sectionId": 297,
      "question": "LEAST PERFORMANCE RESET\n",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_p_l",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 12:18:27",
      "updatedAt": "2024-12-26 12:18:27",
      "answers": [
        {
          "id": 10085,
          "clientId": 78,
          "questionId": 2240,
          "orderNo": 1,
          "desktopText": "LEAST PERFORMANCE RESET",
          "mobileText": "LEAST PERFORMANCE RESET",
          "value": 0,
          "createdAt": "2024-12-26 12:18:27",
          "updatedAt": "2024-12-26 12:18:27"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": strat_l,
      "id": 2538,
      "orderNo": 325,
      "clientId": 78,
      "pageId": 1005,
      "sectionId": 297,
      "question": "LEAST STRATEGIC RESET\n\n",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_str_l",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 12:19:17",
      "updatedAt": "2024-12-26 12:19:17",
      "answers": [
        {
          "id": 10086,
          "clientId": 78,
          "questionId": 2241,
          "orderNo": 1,
          "desktopText": "LEAST STRATEGIC RESET",
          "mobileText": "LEAST STRATEGIC RESET",
          "value": 0,
          "createdAt": "2024-12-26 12:19:17",
          "updatedAt": "2024-12-26 12:19:17"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": vis_l,
      "id": 2539,
      "orderNo": 326,
      "clientId": 78,
      "pageId": 1005,
      "sectionId": 297,
      "question": "LEAST VISIONARY RESET\n",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_vis_l",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 12:19:41",
      "updatedAt": "2024-12-26 12:19:41",
      "answers": [
        {
          "id": 10087,
          "clientId": 78,
          "questionId": 2242,
          "orderNo": 1,
          "desktopText": "LEAST VISIONARY RESET",
          "mobileText": "LEAST VISIONARY RESET",
          "value": 0,
          "createdAt": "2024-12-26 12:19:41",
          "updatedAt": "2024-12-26 12:19:41"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": col_l,
      "id": 2540,
      "orderNo": 327,
      "clientId": 78,
      "pageId": 1005,
      "sectionId": 297,
      "question": "LEAST COLLABORATIVE RESET\n",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_col_l",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2024-12-26 12:20:14",
      "updatedAt": "2024-12-26 12:20:14",
      "answers": [
        {
          "id": 10088,
          "clientId": 78,
          "questionId": 2243,
          "orderNo": 1,
          "desktopText": "LEAST COLLABORATIVE RESET",
          "mobileText": "LEAST COLLABORATIVE RESET",
          "value": 0,
          "createdAt": "2024-12-26 12:20:14",
          "updatedAt": "2024-12-26 12:20:14"
        }
      ],
      "logic": [],
      "questionLanguages": []
    }
  ]
}

// round 2 reset functions

export const starter_reset_payload_round2 = (HeartM,SoulM,MindM,StrengthM,HeartL,SoulL,MindL,StrengthL) => {
  return [
    {
      "answer": SoulM,
      "id": 2542,
      "orderNo": 344,
      "clientId": 78,
      "pageId": 1010,
      "sectionId": 296,
      "question": "MOST SOUL RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_s_m_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:39:01",
      "updatedAt": "2025-02-19 08:39:01",
      "answers": [
        {
          "id": 10210,
          "clientId": 78,
          "questionId": 2271,
          "orderNo": 1,
          "desktopText": "MOST SOUL RESET",
          "mobileText": "MOST SOUL RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:39:01",
          "updatedAt": "2025-02-19 08:39:01"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": MindM,
      "id": 2543,
      "orderNo": 345,
      "clientId": 78,
      "pageId": 1010,
      "sectionId": 296,
      "question": "MOST MIND RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_md_m_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:39:30",
      "updatedAt": "2025-02-19 08:39:30",
      "answers": [
        {
          "id": 10211,
          "clientId": 78,
          "questionId": 2272,
          "orderNo": 1,
          "desktopText": "MOST MIND RESET",
          "mobileText": "MOST MIND RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:39:30",
          "updatedAt": "2025-02-19 08:39:30"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": StrengthM,
      "id": 2544,
      "orderNo": 346,
      "clientId": 78,
      "pageId": 1010,
      "sectionId": 296,
      "question": "MOST STRENGTH RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_st_m_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:39:49",
      "updatedAt": "2025-02-19 08:39:49",
      "answers": [
        {
          "id": 10212,
          "clientId": 78,
          "questionId": 2273,
          "orderNo": 1,
          "desktopText": "MOST STRENGTH RESET",
          "mobileText": "MOST STRENGTH RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:39:49",
          "updatedAt": "2025-02-19 08:39:49"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": HeartL,
      "id": 2545,
      "orderNo": 347,
      "clientId": 78,
      "pageId": 1010,
      "sectionId": 296,
      "question": "LEAST HEART RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_h_l_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:40:10",
      "updatedAt": "2025-02-19 08:40:10",
      "answers": [
        {
          "id": 10213,
          "clientId": 78,
          "questionId": 2274,
          "orderNo": 1,
          "desktopText": "LEAST HEART RESET",
          "mobileText": "LEAST HEART RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:40:10",
          "updatedAt": "2025-02-19 08:40:10"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": SoulL,
      "id": 2546,
      "orderNo": 348,
      "clientId": 78,
      "pageId": 1010,
      "sectionId": 296,
      "question": "LEAST SOUL RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_s_l_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:40:30",
      "updatedAt": "2025-02-19 08:40:30",
      "answers": [
        {
          "id": 10214,
          "clientId": 78,
          "questionId": 2275,
          "orderNo": 1,
          "desktopText": "LEAST SOUL RESET",
          "mobileText": "LEAST SOUL RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:40:30",
          "updatedAt": "2025-02-19 08:40:30"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": MindL,
      "id": 2547,
      "orderNo": 349,
      "clientId": 78,
      "pageId": 1010,
      "sectionId": 296,
      "question": "LEAST MIND RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_md_l_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:40:46",
      "updatedAt": "2025-02-19 08:40:46",
      "answers": [
        {
          "id": 10215,
          "clientId": 78,
          "questionId": 2276,
          "orderNo": 1,
          "desktopText": "LEAST MIND RESET",
          "mobileText": "LEAST MIND RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:40:46",
          "updatedAt": "2025-02-19 08:40:46"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": StrengthL,
      "id": 2548,
      "orderNo": 350,
      "clientId": 78,
      "pageId": 1010,
      "sectionId": 296,
      "question": "LEAST STRENGTH RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_st_l_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:41:08",
      "updatedAt": "2025-02-19 08:41:08",
      "answers": [
        {
          "id": 10216,
          "clientId": 78,
          "questionId": 2277,
          "orderNo": 1,
          "desktopText": "LEAST STRENGTH RESET",
          "mobileText": "LEAST STRENGTH RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:41:08",
          "updatedAt": "2025-02-19 08:41:08"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": HeartM,
      "id": 2556,
      "orderNo": 358,
      "clientId": 78,
      "pageId": 1010,
      "sectionId": 296,
      "question": "MOST HEART RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_h_m_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 09:20:19",
      "updatedAt": "2025-02-19 09:20:19",
      "answers": [
        {
          "id": 10224,
          "clientId": 78,
          "questionId": 2285,
          "orderNo": 2,
          "desktopText": "MOST HEART RESET",
          "mobileText": "MOST HEART RESET",
          "value": 0,
          "createdAt": "2025-02-19 09:20:19",
          "updatedAt": "2025-02-19 09:20:19"
        }
      ],
      "logic": [],
      "questionLanguages": []
    }
  ]
}

export const leader_reset_payload_round2 = (per_m,strat_m,vis_m,col_m,per_l,strat_l,vis_l,col_l) => {
  return [
    {
      "answer": per_m,
      "id": 2541,
      "orderNo": 343,
      "clientId": 78,
      "pageId": 1011,
      "sectionId": 296,
      "question": "MOST PERFORMANCE RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_p_m_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:38:35",
      "updatedAt": "2025-02-19 08:38:35",
      "answers": [
        {
          "id": 10209,
          "clientId": 78,
          "questionId": 2270,
          "orderNo": 1,
          "desktopText": "MOST PERFORMANCE RESET",
          "mobileText": "MOST PERFORMANCE RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:38:35",
          "updatedAt": "2025-02-19 08:38:35"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": strat_m,
      "id": 2549,
      "orderNo": 351,
      "clientId": 78,
      "pageId": 1011,
      "sectionId": 296,
      "question": "MOST STRATEGIC RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_str_m_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:44:47",
      "updatedAt": "2025-02-19 08:44:47",
      "answers": [
        {
          "id": 10217,
          "clientId": 78,
          "questionId": 2278,
          "orderNo": 1,
          "desktopText": "MOST STRATEGIC RESET",
          "mobileText": "MOST STRATEGIC RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:44:47",
          "updatedAt": "2025-02-19 08:44:47"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": vis_m,
      "id": 2550,
      "orderNo": 352,
      "clientId": 78,
      "pageId": 1011,
      "sectionId": 296,
      "question": "MOST VISIONARY RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_vis_m_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:45:03",
      "updatedAt": "2025-02-19 08:45:03",
      "answers": [
        {
          "id": 10218,
          "clientId": 78,
          "questionId": 2279,
          "orderNo": 1,
          "desktopText": "MOST VISIONARY RESET",
          "mobileText": "MOST VISIONARY RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:45:03",
          "updatedAt": "2025-02-19 08:45:03"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": col_m,
      "id": 2551,
      "orderNo": 353,
      "clientId": 78,
      "pageId": 1011,
      "sectionId": 296,
      "question": "MOST COLLABORATIVE RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_col_m_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:45:30",
      "updatedAt": "2025-02-19 08:45:30",
      "answers": [
        {
          "id": 10219,
          "clientId": 78,
          "questionId": 2280,
          "orderNo": 1,
          "desktopText": "MOST COLLABORATIVE RESET",
          "mobileText": "MOST COLLABORATIVE RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:45:30",
          "updatedAt": "2025-02-19 08:45:30"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": per_l,
      "id": 2552,
      "orderNo": 354,
      "clientId": 78,
      "pageId": 1011,
      "sectionId": 296,
      "question": "LEAST PERFORMANCE RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_p_l_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:45:54",
      "updatedAt": "2025-02-19 08:45:54",
      "answers": [
        {
          "id": 10220,
          "clientId": 78,
          "questionId": 2281,
          "orderNo": 1,
          "desktopText": "LEAST PERFORMANCE RESET",
          "mobileText": "LEAST PERFORMANCE RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:45:54",
          "updatedAt": "2025-02-19 08:45:54"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": strat_l,
      "id": 2553,
      "orderNo": 355,
      "clientId": 78,
      "pageId": 1011,
      "sectionId": 296,
      "question": "LEAST STRATEGIC RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_str_l_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:46:12",
      "updatedAt": "2025-02-19 08:46:12",
      "answers": [
        {
          "id": 10221,
          "clientId": 78,
          "questionId": 2282,
          "orderNo": 1,
          "desktopText": "LEAST STRATEGIC RESET",
          "mobileText": "LEAST STRATEGIC RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:46:12",
          "updatedAt": "2025-02-19 08:46:12"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": vis_l,
      "id": 2554,
      "orderNo": 356,
      "clientId": 78,
      "pageId": 1011,
      "sectionId": 296,
      "question": "LEAST VISIONARY RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_vis_l_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:46:38",
      "updatedAt": "2025-02-19 08:46:38",
      "answers": [
        {
          "id": 10222,
          "clientId": 78,
          "questionId": 2283,
          "orderNo": 1,
          "desktopText": "LEAST VISIONARY RESET",
          "mobileText": "LEAST VISIONARY RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:46:38",
          "updatedAt": "2025-02-19 08:46:38"
        }
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": col_l,
      "id": 2555,
      "orderNo": 357,
      "clientId": 78,
      "pageId": 1011,
      "sectionId": 296,
      "question": "LEAST COLLABORATIVE RESET ROUND 2",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_col_l_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:46:57",
      "updatedAt": "2025-02-19 08:46:57",
      "answers": [
        {
          "id": 10223,
          "clientId": 78,
          "questionId": 2284,
          "orderNo": 1,
          "desktopText": "LEAST COLLABORATIVE RESET",
          "mobileText": "LEAST COLLABORATIVE RESET",
          "value": 0,
          "createdAt": "2025-02-19 08:46:57",
          "updatedAt": "2025-02-19 08:46:57"
        }
      ],
      "logic": [],
      "questionLanguages": []
    }
  ]
}

export const walkthrough_payload = (per_m,strat_m,vis_m,col_m,per_l,strat_l,vis_l,col_l) => {
  return [
    {
      "answer": per_m,
      "id": 2286,
      "orderNo": 343,
      "clientId": 78,
      "pageId": 1012,
      "sectionId": 296,
      "question": "Select the statement that MOST accurately represents you.",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_p_m_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:38:35",
      "updatedAt": "2025-02-19 08:38:35",
      "answers": [
        {
          "id": 10225,
          "clientId": 78,
          "questionId": 2286,
          "orderNo": 1,
          "desktopText": "I use logic and clear thinking to solve problems.",
          "mobileText": "I use logic and clear thinking to solve problems.",
          "value": 0,
          "createdAt": "2025-02-19 08:38:35",
          "updatedAt": "2025-02-19 08:38:35"
        },
        {
          "id": 10226,
          "clientId": 78,
          "questionId": 2286,
          "orderNo": 2,
          "desktopText": "I trust my instincts to make decisions.",
          "mobileText": "I trust my instincts to make decisions.",
          "value": 0,
          "createdAt": "2025-02-19 08:38:35",
          "updatedAt": "2025-02-19 08:38:35"
        },
        {
          "id": 10227,
          "clientId": 78,
          "questionId": 2286,
          "orderNo": 3,
          "desktopText": "I focus on building connections and inspiring others.",
          "mobileText": "I focus on building connections and inspiring others.",
          "value": 0,
          "createdAt": "2025-02-19 08:38:35",
          "updatedAt": "2025-02-19 08:38:35"
        },
        {
          "id": 10228,
          "clientId": 78,
          "questionId": 2286,
          "orderNo": 4,
          "desktopText": "I rely on my strength and determination to get things done.",
          "mobileText": "I rely on my strength and determination to get things done.",
          "value": 0,
          "createdAt": "2025-02-19 08:38:35",
          "updatedAt": "2025-02-19 08:38:35"
        },
      ],
      "logic": [],
      "questionLanguages": []
    },
    {
      "answer": per_m,
      "id": 2287,
      "orderNo": 343,
      "clientId": 78,
      "pageId": 1012,
      "sectionId": 296,
      "question": "Great! Now select the statement that LEAST accurately represents you.",
      "placeholder": null,
      "questionType": "assessment",
      "answerType": "multiple_choice",
      "mandatory": "yes",
      "variable": "reset_p_m_r2",
      "na": "no",
      "naValue": null,
      "jumpLogic": "yes",
      "displayLogic": null,
      "createdAt": "2025-02-19 08:38:35",
      "updatedAt": "2025-02-19 08:38:35",
      "answers": [
        {
          "id": 10225,
          "clientId": 78,
          "questionId": 2286,
          "orderNo": 1,
          "desktopText": "I use logic and clear thinking to solve problems.",
          "mobileText": "I use logic and clear thinking to solve problems.",
          "value": 0,
          "createdAt": "2025-02-19 08:38:35",
          "updatedAt": "2025-02-19 08:38:35"
        },
        {
          "id": 10226,
          "clientId": 78,
          "questionId": 2286,
          "orderNo": 2,
          "desktopText": "I trust my instincts to make decisions.",
          "mobileText": "I trust my instincts to make decisions.",
          "value": 0,
          "createdAt": "2025-02-19 08:38:35",
          "updatedAt": "2025-02-19 08:38:35"
        },
        {
          "id": 10227,
          "clientId": 78,
          "questionId": 2286,
          "orderNo": 3,
          "desktopText": "I focus on building connections and inspiring others.",
          "mobileText": "I focus on building connections and inspiring others.",
          "value": 0,
          "createdAt": "2025-02-19 08:38:35",
          "updatedAt": "2025-02-19 08:38:35"
        },
        {
          "id": 10228,
          "clientId": 78,
          "questionId": 2286,
          "orderNo": 4,
          "desktopText": "I rely on my strength and determination to get things done.",
          "mobileText": "I rely on my strength and determination to get things done.",
          "value": 0,
          "createdAt": "2025-02-19 08:38:35",
          "updatedAt": "2025-02-19 08:38:35"
        },
      ],
      "logic": [],
      "questionLanguages": []
    },
  ]
}